import React, {FC} from 'react';

import {defaultPositions} from './QuestionMarkup.constants';
import {QuestionMarkupProps} from './QuestionMarkup.types';

const QuestionMarkup: FC<QuestionMarkupProps> = ({positions = defaultPositions, ...props}) => {
    return (
        <>
            {positions.map(
                (item) => props[item] && <React.Fragment key={item}>{props[item]}</React.Fragment>,
            )}
        </>
    );
};
export default QuestionMarkup;
